import classNames from "classnames/bind";
import React, { useMemo } from "react";
import styles from "./DateSelector.module.scss";
import { getStringValueFromDate } from "./dateSelectorHelpers";
import type { DateRangeValue, DateSelectorValueProps } from "./types";

const cx = classNames.bind(styles);

// IMPROVE: this sub-component needs a refactor. there are many code smells here.
const DateSelectorValue = ({
  variant,
  value,
  isRange,
  placeholder = "",
  isMenuOpen = false,
}: DateSelectorValueProps) => {
  const fromValue = useMemo(
    () =>
      value instanceof Date || value?.from
        ? getStringValueFromDate({
            variant,
            value: value instanceof Date ? value : value.from,
          })
        : "Start Date",
    [value, variant]
  );

  const toValue = useMemo(
    () =>
      (isRange || !["day", "time"].includes(variant)) &&
      (value as DateRangeValue)?.to
        ? getStringValueFromDate({
            variant,
            value: value instanceof Date ? value : value?.to,
          })
        : "End Date",
    [value, variant]
  );

  const stringValue = useMemo(() => {
    if (!isRange) {
      if (variant === "week") {
        return `${fromValue} - ${toValue}`;
      } else {
        return value instanceof Date || value?.from
          ? getStringValueFromDate({
              variant,
              value: value instanceof Date ? value : value.from,
            })
          : placeholder;
      }
    }

    return `${fromValue} - ${toValue}`;
  }, [fromValue, toValue, isRange, variant, placeholder]);

  if (isRange) {
    return (
      <p className={cx("value", { placeholder: stringValue === placeholder })}>
        <span
          className={cx({
            ["isActive-date"]: fromValue === "Start Date" && isMenuOpen,
            placeholder: fromValue === "Start Date",
          })}
        >
          {fromValue}
        </span>
        <span> - </span>
        <span
          className={cx({
            ["isActive-date"]:
              fromValue !== "Start Date" &&
              toValue === "End Date" &&
              isMenuOpen,
            placeholder: fromValue !== "Start Date" && toValue === "End Date",
          })}
        >
          {toValue}
        </span>
      </p>
    );
  }

  return (
    <p className={cx("value", { placeholder: stringValue === placeholder })}>
      {stringValue}
    </p>
  );
};

export default DateSelectorValue;
